<template>
  <v-dialog v-model="showChangePassword" persistent max-width="320px">
    <v-card>
      <v-card-title>
        <span class="headline" style="font-weight:bold">Change Password</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Enter New Password *"
                type="password"
                v-model="newPassword.password"
                :rules="[ 
                  () => (!!newPassword.password) || 'Mandatory Field',
                  () => (!!newPassword.password && newPassword.password.length > 6 && newPassword.password.length < 15) ||
                    'Must be between 6 and 14 characters'
                 ]"
                :maxlength="14"
                counter="14"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Confirm Password *"
                type="password"
                v-model="newPassword.confirmation"
                :rules="[ 
                  () => (!!newPassword.confirmation) || 'Mandatory Field',
                  () => (!!newPassword.confirmation && newPassword.confirmation.length > 6 && newPassword.confirmation.length < 15) ||
                    'Must be between 6 and 14 characters'
                 ]"
                :maxlength="14"
                counter="14"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="gray darken-1" text @click="hide()">Cancel</v-btn>
        <v-btn
          id="primary"
          color="blue darken-1"
          text
          @click="save()"
          :disabled="(newPassword.password == null) || (newPassword.password.length < 6 || newPassword.password.length > 14) || (newPassword.password != newPassword.confirmation)"
        >Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "./../../../plugins/axios";

export default {
  name: "ChangePassword",
  props: ["showChangePassword", "userData"],
  data: function() {
    return {
      newPassword: {
        password: null,
        confirmation: null
      }
    };
  },
  methods: {
    hide: function() {
      this.showChangePassword = false
    },
    save: function() {
      axios
        .get(
          "/wiom/UpdatePassword?username=" +
            this.userData.username +
            "&oldPassword=" +
            this.userData.password +
            "&newPassword=" +
            this.newPassword.password
        )
        .then(response => {
          if (response.data.data == true) {
            this.$emit("updated-password", this.newPassword.password);
          }
        });
    }
  }
};
</script>